/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { useEffect, useRef } from 'react'
import { HeroChevron } from './icons.jsx'

function HeroVideo() {
  const ref = useRef(null)
  useEffect(() => {
    const v = ref.current
    if (!v) return
    if (!v.getAttribute('src')) v.src = v.getAttribute(window.innerWidth < 768 ? 'data-m' : 'data-d')
    v.muted = true
    v.loop = true
    v.play().catch(() => {})
  }, [])
  return (
    <div className="seq-hero-video-wrap">
      <video
        ref={ref}
        id="heroVideo"
        data-d="a/hero.mp4"
        data-m="a/hero-m.mp4"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        poster="a/hero-p.webp"
        controlsList="nodownload nofullscreen noremoteplayback"
        disablePictureInPicture
        onContextMenu={(e) => e.preventDefault()}
      />
    </div>
  )
}

export default function Hero() {
  return (
    <div className="lp-hero">
      <div className="lp-hero-video">
        <HeroVideo />
      </div>
      <div className="lp-hero-go">
        <div className="lp-hero-go-w">
          <a className="lp-hero-go-a" href="#scroll-here" aria-label="ادامه">
            <HeroChevron className="lp-hero-go-svg" />
          </a>
        </div>
      </div>
    </div>
  )
}
